/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { login, logout } from '../../actions/auth_actions';
import { fetchChangePassword } from '../../actions/user_actions';
import ReactBSAlert from "react-bootstrap-sweetalert";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      recover: false,
      change_password: false,
      emailLogin: "",
      passwordLogin: "", 
      email: "",
      alert: null
    };
  }

  componentDidMount() {
    document.body.classList.toggle("login-page");
  }

  componentWillUnmount() {
    document.body.classList.toggle("login-page");
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps.auth)
    if(nextProps && nextProps.auth && nextProps.auth.token) {
      let date = new Date();
      console.log(date.toUTCString(), date.getTime(), date.getTime() + 3600000);
      document.cookie = `idToken=${nextProps.auth.token.idToken}; max-age=${60*60*3}; path=/`
      document.cookie = `refreshToken=${nextProps.auth.token.refreshToken}; max-age=${60*60*3}; path=/`
      this.setState({ login: true });
    }
    if(nextProps && nextProps.auth && nextProps.auth.fetchError && nextProps.auth.fetchError === "Authentication failed") {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <div>
              Wrong user and/or password.
            </div>
          </div>
        ),
        type: "danger",
        icon: "tim-icons icon-simple-remove",
        autoDismiss: 7
      };
      // console.log(options)
      this.refs.notificationAlert.notificationAlert(options);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.props.user, prevProps.user)
    if(this.props.user && this.props.user.password_changed && prevProps.user && !prevProps.user.password_changed){
      this.setState({
        alert: (
          <ReactBSAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Notification"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="success"
            btnSize=""
          >
            Notification sent. Please check your email!
          </ReactBSAlert>
        )
      });
    }
  }

  verifyEmail = value => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  change = (event, stateName, type) => {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  };

  handleEmail = (event) => {
    this.setState({ emailLogin: event.target.value });
  }

  handlePassword = (event) => {
    this.setState({ passwordLogin: event.target.value });
  }

  handleLogin = () => {
    const { emailLogin, passwordLogin } = this.state;
    const { login } = this.props;
    login({emailLogin, passwordLogin});
  }
  
  handlePasswordChange = () => {
    this.setState({ change_password: true })
  }

  handleRecover = () => {
    this.setState({recover: !this.state.recover})
  }

  handleEmailRecover = (event) => {
    this.setState({ email: event.target.value })
  }

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  handleChangePassword = () => {
    const { email } = this.state;
    const { fetchChangePassword } = this.props;
    let objChangePassword = {
      email: email
    }
    console.log(objChangePassword)
    fetchChangePassword(objChangePassword);
    this.setState({recover: !this.state.recover});
  }
  
  render() {
    if(this.state.login) {
      return <Redirect from="/auth/login" to="/user/models" />
    }
    if(this.state.change_password) {
      return <Redirect from="/auth/login" to="/auth/password-change" />
    }

    return (
      <>
        <div className="rna-container">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <div className="content">
          {this.state.alert}
          <Container>
            <Col className="ml-auto mr-auto" lg="4" md="6">
              <Form className="form">
                <Card className="card-login card-white">
                  <CardHeader style={{height: "185px", display: "flex", justifyContent: "center"}}>
                    <img
                      alt="..."
                      src={require("assets/img/scoring.png")}
                      style={{width: "85%", marginTop: "20px"}}
                    />
                    {/* <CardTitle tag="h1">Log in</CardTitle> */}
                  </CardHeader>
                  <CardBody>
                    <InputGroup
                      className={classnames({
                        "input-group-focus": this.state.emailFocus
                      })}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="tim-icons icon-email-85" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Email"
                        type="text"
                        onFocus={e => this.setState({ emailFocus: true })}
                        onBlur={e => this.setState({ emailFocus: false })}
                        onChange={e => this.handleEmail(e)}
                      />
                    </InputGroup>
                    <InputGroup
                      className={classnames({
                        "input-group-focus": this.state.passFocus
                      })}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="tim-icons icon-lock-circle" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Password"
                        type="password"
                        onFocus={e => this.setState({ passFocus: true })}
                        onBlur={e => this.setState({ passFocus: false })}
                        onChange={e => this.handlePassword(e)}
                      />
                    </InputGroup>
                  </CardBody>
                  <CardFooter>
                    <Button
                      block
                      className="mb-3"
                      color="default"
                      // href="#pablo"
                      onClick={this.handleLogin.bind(this)}
                      size="lg"
                    >
                      Login
                    </Button>
                    <div className="pull-left">
                      <h6>
                        <a
                          className="link footer-link"
                          href="#"
                          onClick={this.handleRecover}
                        >
                          Recover Password
                        </a>
                      </h6>
                    </div>
                    <div style={{marginTop: "40px"}}>
                      <img
                        alt="..."
                        src={require("assets/img/kin.jpg")}
                        style={{width: "100px"}}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </Form>
              <Modal
                isOpen={this.state.recover}
                toggle={this.handleRecover}
              >
                <div className="modal-header" style={{justifyContent: 'center'}}>
                  <h4 className="modal-title" id="myModalLabel">
                    Password Recovery
                  </h4>
                </div>
                <ModalBody className="card-login card-white">
                  Write your email
                  <InputGroup
                    className={classnames({
                      "input-group-focus": this.state.emailFocus
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="tim-icons icon-email-85" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email"
                      type="text"
                      onFocus={e => this.setState({ emailFocus: true })}
                      onBlur={e => this.setState({ emailFocus: false })}
                      onChange={this.handleEmailRecover}
                    />
                  </InputGroup>
                </ModalBody>
                <div className="modal-footer justify-content-center">
                  <Button
                    className="btn-round"
                    color="info"
                    data-dismiss="modal"
                    type="button"
                    onClick={this.handleChangePassword}
                  >
                    Recover
                  </Button>
                </div>
              </Modal>
            </Col>
          </Container>
        </div>
      </>
    );
  }
}

function mapStateToProps({auth, user}){
  return{
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { login, logout, fetchChangePassword }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
